/*
This computer program, as defined in the Copyright, Designs and Patents Act 1998 and the Software Directive (2009/24/EC), 
is the copyright of Logic Valley Ltd, a wholly owned subsidiary of Marston (Holdings) Ltd. All rights are reserved.
*/

/**
 * FuzzyVRMHeader.js
 * @description Header component for the Fuzzy VRM page.
 * Displays the page title and provides a back navigation button.
 * This is a presentational component with no business logic.
 *
 * @component
 * @example
 * return (
 *   <FuzzyVRMHeader
 *     title="Fuzzy VRM MT6789"
 *     onBackClick={() => navigate(-1)}
 *   />
 * )
 */
import React from 'react'
import backArrow from '../../../../../../assets/static/backArrow.svg'

/**
 * @param {Object} props - Component props
 * @param {string} props.title - The title text to display in the header
 * @param {Function} props.onBackClick - Callback function when back button is clicked
 * @returns {JSX.Element} The rendered header component
 */
const FuzzyVRMHeader = ({ title, onBackClick }) => {
  return (
    <div className="fuzzyVRM__header">
      <div className="fuzzyVRM__header-left">
        <img
          src={backArrow}
          alt="Back"
          onClick={onBackClick}
          className="fuzzyVRM__back-icon"
        />
        <p className="fuzzyVRM__title">{title}</p>
      </div>
    </div>
  )
}

export default FuzzyVRMHeader
